import { FOCUS_RING } from "./focusRing.constants"

export const MENU_PANEL_CLASS =
    "flex min-w-[180px] flex-col rounded-card bg-surface p-1.5 text-ink shadow-float focus-visible:outline-none"

export const MENU_ITEM_CLASS =
    "flex cursor-default select-none items-center gap-2 rounded-field px-2.5 py-1.5 text-left text-callout text-ink outline-none transition-colors data-[highlighted]:bg-offwhite data-[disabled]:pointer-events-none data-[disabled]:text-ink-3"

export const MENU_DESTRUCTIVE_ITEM_CLASS =
    "text-tone-red-ink data-[highlighted]:bg-tone-red/50"

export const MENU_TRIGGER_CLASS = `flex h-8 min-w-8 items-center justify-center rounded-full text-ink-2 transition-colors hover:bg-ink/[0.05] hover:text-ink ${FOCUS_RING} disabled:pointer-events-none disabled:text-ink-3`
